import React from "react";

function Housesvg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
            className="icon icon-tabler icon-tabler-building-community"
            viewBox="0 0 24 24"
        >
            <path stroke="none" d="M0 0h24v24H0z"></path>
            <path d="M8 9l5 5v7H8v-4m0 4H3v-7l5-5m1 1V4a1 1 0 011-1h10a1 1 0 011 1v17h-8"></path>
            <path d="M13 7L13 7.01"></path>
            <path d="M17 7L17 7.01"></path>
            <path d="M17 11L17 11.01"></path>
            <path d="M17 15L17 15.01"></path>
        </svg>
    );
}

export default Housesvg;